export default __webpack_public_path__ + "static/simple-column-94668e3b61afd97f1921d30dc62c7d30.png";